module.exports = import("https://uat1.billdesk.com/merchant-uat/sdk/dist/billdesksdk.js");;